import { RetourNc as RetourNcGql, REtourNcTypeEnum } from '@graphql/generated';
import { DocumentFileModel } from '@lib/ged/document.model';
import { RetourNc } from '@lib/models/non-conformite/retour-nc.model';
import { FileDispositionMapper } from './file-disposition-mapper';

export class RetourNcsMapper {
  public static fromGraphQl(
    inputs: RetourNcGql[] | undefined,
    documentId: number,
    isBackOffice = false
  ): RetourNc[] | undefined {
    if (
      !inputs ||
      (isBackOffice &&
        inputs.filter(input => !input.isVisibleBackOffice).length === inputs.length)
    ) {
      return undefined;
    }

    const result: RetourNc[] = [];

    inputs.forEach(input =>
      result.push({
        documentId: documentId,
        dateCreation: input.dateCreation,
        type: input.type == REtourNcTypeEnum.File ? 'file' : 'note',
        note: input.note ?? undefined,
        comment: input.commentaire ?? undefined,
        files:
          input.files?.map(
            f =>
              ({
                filename: f.fileName,
                disposition: FileDispositionMapper.fromGraphQl(f.disposition),
                gedId: f.gedId,
              }) as DocumentFileModel
          ) ?? [],
      })
    );

    return result.sort((a, b) => (a.dateCreation < b.dateCreation ? 1 : -1));
  }
}
